// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__9UA5q","overflowing":"ReadFullNote_overflowing__16bVN"};